import * as React from "react"

export const ArrowLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="m6.498 10.542 4.268 4.267-.766.774L4.417 10 10 4.417l.766.774-4.268 4.267h9.085v1.084z"
    ></path>
  </svg>
)
